import { useTranslation } from 'react-i18next';
import { SupportedLanguage } from '../types/supportedLanguage';

/**
 * Custom hook for handling language switching in a React application.
 *
 * @returns An object containing the current language and a function to switch languages.
 */
export const useLanguage = () => {
  const { i18n } = useTranslation();
  const isEnLocale = i18n.language.toLocaleLowerCase().includes('en');
  const isFrLocale = i18n.language.toLocaleLowerCase().includes('fr');

  /**
   * A function to switch the language of the application.
   *
   * @param locale - The new language to switch to, as a SupportedLanguage value.
   */
  const switchLanguage = (locale: SupportedLanguage) => {
    i18n.changeLanguage(locale);
  };
  const language = isEnLocale ? 'en' : isFrLocale ? 'fr' : 'pt';

  return {
    language,
    switchLanguage,
  };
};
